<template>
  <div class="jm-lesson-select">
    <el-select
      v-bind="$attrs"
      v-for="(val, key) in channels"
      :key="key"
      v-model="lessonModel[key]"
      class="jm-input135"
      @change="(v) => changeLesson(v, key)"
      :ref="key"
    >
      <el-option
        v-for="item in val"
        :label="item.name"
        :value="item.id"
        :key="item.id">
        <span :style="`color:${item.color}`">{{ item.name }}</span>
      </el-option>
    </el-select>
  </div>
</template>


<script>
import lockr from 'lockr';

export default {
  name: 'JmLessonSelect',
  model: {
    event: 'change',
  },
  props: {
    value: {
      type: [String, Object],
      default: '',
    },
    excludeDisable: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      cacheKey: 'channels',
      channelData: [],
      lessonModel: {
        sign_lesson_1: '',
        sign_lesson_2: '',
        sign_lesson_3: '',
        sign_lesson_4: '',
        sign_lesson_5: '',
      },
      channels: {
        sign_lesson_1: [],
        sign_lesson_2: [],
        sign_lesson_3: [],
        sign_lesson_4: [],
        sign_lesson_5: [],
      },
      inited: false,
      loading: true,
    };
  },
  methods: {
    nextKey(key) {
      const keys = Object.keys(this.channels);
      if (key === '') {
        return keys[0];
      }
      for (let i = 0; i < keys.length; i++) {
        if (key === keys[i]) {
          let nextIndex = i + 1;
          return nextIndex === keys.length ? false : keys[nextIndex];
        }
      }
    },
    /**
     * 获取渠道数据
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @return {Promise} [description]
     */
    getChannelData() {
      return new Promise((resolve) => {
        this.$http._get({
          url: '/index/api_base/getSignLesson',
        }).then(({ data }) => {
          lockr.set(this.cacheKey, data);
          return resolve(data);
        });
      });
    },
    /**
     * 验证缓存数据是否为最新，否则获取最新数据
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @return {Promise}
     */
    getChannels() {
      const channels = lockr.get(this.cacheKey);
      if (!channels) {
        return Promise.resolve(this.getChannelData());
      }

      return new Promise((resolve) => {
        this.$http._get({
          url: '/index/api_base/getSignLesson/update_time/1',
        }).then(({ data }) => {
          if (data !== channels.update_time) {
            resolve(this.getChannelData());
          }
          resolve(channels);
        });
      });
    },
    /**
     * 获取渠道
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @param  {Number} pid
     * @param  {String} level
     * @return {Boolean}
     */
    changeLesson(pid = 0, level = '') {
      const nextKey = this.nextKey(level);
      if (nextKey === false) {
        return true;
      }
      this.channels[nextKey] = this.channelData.filter((item) => {
        return item.pid === pid;
      });
      this.$emit('change', this.lessonModel);
    },
    /**
     * 重制子渠道选项内容
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @param  {String} level [description]
     */
    resetSubChannel(level) {
      const key = this.nextKey(level);
      this.lessonModel[key] = '';
      this.channels[key] = [];
    },

    resetSub(nV, oV, level) {
      if (nV !== oV && this.inited) {
        this.resetSubChannel(level);
        this.changeLesson(nV, level);
      }
    },
    /**
     * 设置渠道焦点
     */
    focus(channelKey = 'sign_lesson_1') {
      this.$refs[channelKey][0].focus();
    }
  },
  mounted() {
    this.getChannels().then(({ channels }) => {
      this.channelData = channels;
      let nextKey = '';
      let pid = 0;
      while (nextKey !== false) {
        this.changeLesson(pid, nextKey);
        nextKey = this.nextKey(nextKey);
        pid = this.value[nextKey];
        if (!pid) {
          break;
        }
      }
      this.inited = true;
      this.lessonModel = this.value;
    });
  },
  watch: {
    value(v) {
      this.lessonModel = v;
    },
    'lessonModel.sign_lesson_1'(v, ov) {
      this.resetSub(v, ov, 'sign_lesson_1');
    },
    'lessonModel.sign_lesson_2'(v, ov) {
      this.resetSub(v, ov, 'sign_lesson_2');
    },
    'lessonModel.sign_lesson_3'(v, ov) {
      this.resetSub(v, ov, 'sign_lesson_3');
    },
    'lessonModel.sign_lesson_4'(v, ov) {
      this.resetSub(v, ov, 'sign_lesson_4');
    },
  },
};
</script>

<style>
  .jm-channel-select {
    display: inline-block;
  }
  .jm-channel-select .el-select {
    margin-right: 4px;
  }
</style>
